import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../abstract_input';

export default class Label extends AbstractInput {
    constructor(props) {
        super(props);
    }

    render () {
        return (
            <label htmlFor={this.props.htmlFor} className={this.props.className} {...this.props.attributes}>{this.props.label}</label>
        )
    }
}

Label.propTypes = {
    htmlFor: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    required: PropTypes.bool
};

Label.defaultProps = {
    required: false
};